type DangerousTranslateProps = {
  text?: string | null
}
export const DangerousTranslate = ({ text = '' }: DangerousTranslateProps) => {
  return <span dangerouslySetInnerHTML={{ __html: text || '' }}></span>
}
